import type { ComponentProps } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';
import type { FooterCreateButtons as FooterCreateButtonsComponent } from '@confluence/create-blank-fabric-page/entry-points/FooterCreateButtons.ts';

export const FooterCreateButtons: LoadableType<
	ComponentProps<typeof FooterCreateButtonsComponent>
> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-FooterCreateButtons" */ '@confluence/create-blank-fabric-page/entry-points/FooterCreateButtons.ts'
			)
		).FooterCreateButtons,
});
